export var LimitType;
(function (LimitType) {
    LimitType[LimitType["SPENDING"] = 0] = "SPENDING";
})(LimitType || (LimitType = {}));
export var LimitPeriod;
(function (LimitPeriod) {
    LimitPeriod[LimitPeriod["DAILY"] = 0] = "DAILY";
    LimitPeriod[LimitPeriod["NIGHTLY"] = 1] = "NIGHTLY";
    LimitPeriod[LimitPeriod["ALL"] = 2] = "ALL";
})(LimitPeriod || (LimitPeriod = {}));
export var LimitTarget;
(function (LimitTarget) {
    LimitTarget[LimitTarget["PERSON"] = 0] = "PERSON";
    LimitTarget[LimitTarget["ORGANIZATION"] = 1] = "ORGANIZATION";
    LimitTarget[LimitTarget["ALL"] = 2] = "ALL";
})(LimitTarget || (LimitTarget = {}));
export var AccountTransactionalLimitValueStatus;
(function (AccountTransactionalLimitValueStatus) {
    AccountTransactionalLimitValueStatus[AccountTransactionalLimitValueStatus["PENDING"] = 1] = "PENDING";
    AccountTransactionalLimitValueStatus[AccountTransactionalLimitValueStatus["REALIZED"] = 2] = "REALIZED";
    AccountTransactionalLimitValueStatus[AccountTransactionalLimitValueStatus["FAILED"] = 3] = "FAILED";
})(AccountTransactionalLimitValueStatus || (AccountTransactionalLimitValueStatus = {}));
